import { render } from "./ProductsByCategory.vue?vue&type=template&id=6ae95f3c&scoped=true"
import script from "./ProductsByCategory.vue?vue&type=script&lang=js"
export * from "./ProductsByCategory.vue?vue&type=script&lang=js"

import "./ProductsByCategory.vue?vue&type=style&index=0&id=6ae95f3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae95f3c"]])

export default __exports__